export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 3a1 1 0 01.895.553l8 16a1 1 0 01-1.382 1.32L12 16.683l-7.513 4.19a1.001 1.001 0 01-1.381-1.32l8-16 .07-.121A1 1 0 0112 3zM6.344 17.547l5.169-2.882c.303-.169.672-.169.974 0l5.168 2.882L12 6.237l-5.656 11.31z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};